module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "tab-detart-manage",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-form', {
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "联系人电话 / 客户地址"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchVal.searchText),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "searchText", $$v)
            },
            expression: "searchVal.searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "拜访日期"
          },
          model: {
            value: (_vm.searchVal.payVisitDate),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "payVisitDate", $$v)
            },
            expression: "searchVal.payVisitDate"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "110px"
          },
          attrs: {
            "placeholder": "拜访方式",
            "clearable": ""
          },
          model: {
            value: (_vm.searchVal.payVisitStatus),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "payVisitStatus", $$v)
            },
            expression: "searchVal.payVisitStatus"
          }
        }, _vm._l((_vm.visitStatusList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "110px"
          },
          attrs: {
            "placeholder": "审核状态",
            "clearable": ""
          },
          model: {
            value: (_vm.searchVal.auditStatus),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "auditStatus", $$v)
            },
            expression: "searchVal.auditStatus"
          }
        }, _vm._l((_vm.checkStatusList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), (_vm.userInfo.type != 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "plain": "",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addForm
          }
        }, [_vm._v("新\n          增")]) : _vm._e()], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          ref: "companyTabRef",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "row-style": {
              height: '50px'
            }
          },
          on: {
            "selection-change": _vm.handerSectionChange,
            "row-click": _vm.handerRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "50"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "70"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payVisitDate",
            "width": "120",
            "label": "拜访日期",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.payVisitDate ? scope.row.payVisitDate.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminUserName",
            "width": "100",
            "label": "客户经理",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.adminUserName ? scope.row.adminUserName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "successfulManagerName",
            "width": "110",
            "label": "客户成功经理",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ? scope.row.successfulManagerName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "agencyManagerName",
            "width": "100",
            "label": "经销商",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ? scope.row.agencyManagerName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "contactUser",
            "width": "120",
            "label": "联系人",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "contactPhone",
            "width": "120",
            "label": "联系人电话",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.contactPhone ? scope.row.contactPhone : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payVisitStatus",
            "width": "120",
            "label": "拜访方式",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag-fill",
                class: scope.row.payVisitStatus == 1 ? 'pruple' : (scope.row.payVisitStatus == 2 ? 'primary' : 'warning')
              }, [_vm._v("\n            " + _vm._s(scope.row.payVisitStatus == 1 ? "电话沟通" : (scope.row.payVisitStatus == 2 ? '客户现场' : '视频会议')) + "\n          ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "auditStatus",
            "width": "120",
            "label": "审核状态",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.auditStatus == 1 ? 'warning' : 'primary'
              }, [_vm._v("\n            " + _vm._s(scope.row.auditStatus == 1 ? "待审核" : '已审核') + "\n          ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "position",
            "label": "职位",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.position ? scope.row.position : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "addressInfo",
            "label": "客户地址",
            "min-width": "150",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.addressInfo || '') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 1)
                  }
                }
              })]), _vm._v(" "), (scope.row.auditStatus == 1 && _vm.userInfo.id == scope.row.createUser) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e(), _vm._v(" "), (scope.row.auditStatus == 1 && _vm.userInfo.id == scope.row.createUser) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), (_vm.visible) ? _c('ModalForm', {
          attrs: {
            "visible": _vm.visible,
            "mode": _vm.mode,
            "visitStatusList": _vm.visitStatusList,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            "getList": _vm.getList
          }
        }) : _vm._e(), _vm._v(" "), (_vm.visibleView) ? _c('ModalFormView', {
          attrs: {
            "visible": _vm.visibleView,
            "visitStatusList": _vm.visitStatusList,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleView = $event
            },
            "getList": _vm.getList
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3637fe32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/TrackManage/index.vue
// module id = 1783
// module chunks = 9